import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { Menu } from "lucide-react";

function PublicHomepage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);



  return (
    <>
      <Helmet>
        <title>Welcome - DairyKhataBook</title>
      </Helmet>

      <div className="relative w-full h-screen bg-gradient-to-br from-indigo-50 to-white overflow-hidden flex flex-col">
        {/* Decorative Shapes */}
        <div className="absolute top-[-100px] left-[-100px] w-80 h-80 bg-indigo-200 rounded-full opacity-30 animate-pulse"></div>
        <div className="absolute bottom-[-80px] right-[-80px] w-72 h-72 bg-pink-200 rounded-full opacity-20 animate-pulse"></div>

        {/* Header */}
        <header className="flex justify-between items-center p-4 md:p-8 z-10">
          <div className="text-2xl md:text-3xl font-bold text-indigo-600">
            DairyKhataBook
          </div>

          <div className="relative">
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="p-2 rounded-full hover:bg-indigo-100 transition"
            >
              <Menu className="w-6 h-6 text-indigo-600" />
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-white shadow-lg rounded-md border border-gray-200 z-50">
                <ul className="flex flex-col">
                  <li>
                    <button
                      onClick={() => navigate("/Contact")}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100"
                    >
                      Contact
                    </button>
                  </li>
                  <li>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate("/PrivacyPolicy")}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100"
                    >
                      Privacy Policy
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </header>

        {/* Main Hero Section */}
        <main className="flex-1 flex flex-col justify-center items-center text-center px-4">
          {/* Animated Logo */}
          <motion.div
            className="mb-8 relative"
            animate={{ rotate: [0, 10, -10, 0] }}
            transition={{ repeat: Infinity, duration: 3 }}
          >
            <img
              src="/images/logo.png"
              alt="Logo"
              className="w-32 h-32 md:w-40 md:h-40 mx-auto rounded-full shadow-lg"
            />
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-24 h-1 bg-indigo-300 rounded-full animate-pulse"></div>
          </motion.div>

          {/* Hero Text */}
          <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Manage Your Dairy Business Effortlessly
          </h1>
          <p className="text-gray-600 mb-8 max-w-md md:text-lg px-2">
            Sign in to track your dairy entries, payments, and farm management
            with ease.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
            <button
              onClick={() => navigate("/login")}
              className="w-full sm:max-w-sm px-8 py-5 bg-indigo-600 text-white rounded-xl font-semibold text-lg hover:bg-indigo-700 transition shadow-lg"
            >
              Login
            </button>
            <button
              onClick={() => navigate("/register")}
              className="w-full sm:max-w-sm px-8 py-5 bg-white border border-gray-300 text-gray-800 rounded-xl font-semibold text-lg hover:bg-gray-50 transition shadow-lg"
            >
              Register
            </button>
          </div>
        </main>

        {/* Footer */}
        <footer className="text-center p-4 text-gray-500 text-sm">
          © {new Date().getFullYear()} DairyKhataBook. All rights reserved.
        </footer>
      </div>
    </>
  );
}

export default PublicHomepage;
